import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Components
import EventFormContainer from './EventForm/EventFormContainerV2';

class EventFormModal extends Component {
  constructor(props) {
    super(props);

    this.toggleCommonQs = this.toggleCommonQs.bind(this);
    this.toggleAttireOs = this.toggleAttireOs.bind(this);
    this.toggleOtherDetails = this.toggleOtherDetails.bind(this);
    this.showExpandedModal = this.showExpandedModal.bind(this);

    this.state = {
      commonQs: false,
      attireOs: false,
      showOtherDetails: false,
    };
  }

  componentDidMount() {
    this.showExpandedModal();
  }

  toggleCommonQs() {
    this.setState(state => ({ commonQs: !state.commonQs }));
  }

  toggleAttireOs() {
    this.setState(state => ({ attireOs: !state.attireOs }));
  }

  toggleOtherDetails() {
    this.setState(state => ({ showOtherDetails: !state.showOtherDetails }));
  }

  showExpandedModal() {
    const { selectedId } = this.props;

    if (selectedId) {
      this.setState({ showOtherDetails: true });
    }
  }

  render() {
    const {
      selectedId,
      collectRsvps,
      websiteEvent,
      handleEventFormClose,
      numberOfGuests,
      numberOfEvents,
    } = this.props;
    const { commonQs, attireOs } = this.state;
    let modalTitle = selectedId ? 'Edit Event' : 'Add Event';

    if (attireOs) modalTitle = 'Most Common Attires Suggested By Zola Couples';
    if (commonQs) modalTitle = 'Most Common Questions Asked By Zola Couples';

    return (
      <div id="event-modal-v2" className="event-modal -v2">
        <div className="modal__header">
          <h3 className="modal__title">{ modalTitle }</h3>
        </div>
        <div className="modal__body">
          <EventFormContainer
            isAttire={attireOs}
            isCommonQs={commonQs}
            onToggleCommonQs={this.toggleCommonQs}
            onToggleAttireOs={this.toggleAttireOs}
            onToggleOtherDetails={this.toggleOtherDetails}
            websiteEvent={websiteEvent}
            collectRsvps={collectRsvps}
            showOtherDetails={this.state.showOtherDetails}
            handleEventFormClose={handleEventFormClose}
            numberOfGuests={numberOfGuests}
            numberOfEvents={numberOfEvents}
          />
        </div>
      </div>
    );
  }
}

EventFormModal.propTypes = {
  selectedId: PropTypes.number,
  collectRsvps: PropTypes.bool,
  websiteEvent: PropTypes.bool,
  handleEventFormClose: PropTypes.func,
  numberOfGuests: PropTypes.number,
  numberOfEvents: PropTypes.number,
};

EventFormModal.defaultProps = {
  handleEventFormClose: () => {},
};

const mapStateToProps = state => ({
  selectedId: state.events.events.selectedId || state.website.entities.selectedEntityId,
});

export default connect(
  mapStateToProps,
)(EventFormModal);



// WEBPACK FOOTER //
// ./src/components/manage/common/EventFormModalV2.jsx